import { render, staticRenderFns } from "./PullDetail.vue?vue&type=template&id=300b98c2&scoped=true&"
import script from "./PullDetail.vue?vue&type=script&lang=ts&"
export * from "./PullDetail.vue?vue&type=script&lang=ts&"
import style0 from "./PullDetail.vue?vue&type=style&index=0&id=300b98c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "300b98c2",
  null
  
)

export default component.exports